import { QueryClient } from "@tanstack/vue-query";

export const queryClient = new QueryClient();
